import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from './locales/en/translation.json'
import translationSV from './locales/sv/translation.json'

export const defaultNS = 'translation'
export const resources = {
  en: {
    translation: translationEN,
  },
  sv: {
    translation: translationSV,
  },
} as const

export const initTranslations = () => {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: 'sv',
      fallbackLng: 'sv',
      debug: false,
      supportedLngs: ['en', 'sv'],
      defaultNS: [defaultNS],
      interpolation: {
        escapeValue: false,
      },
    })
    .catch((error) => {
      console.error('Translation initialization failed:', error)
    })
}
